'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadmaskActions = exports.hideLoadmask = exports.showLoadmask = undefined;

var _constants = require('./constants');

var showLoadmask = exports.showLoadmask = function showLoadmask() {
  return { type: _constants.SHOW_LOADMASK };
};

var hideLoadmask = exports.hideLoadmask = function hideLoadmask() {
  return { type: _constants.HIDE_LOADMASK };
};

/**
 * User 'should' be able to rename these if needed
 */
var loadmaskActions = exports.loadmaskActions = { showLoadmask: showLoadmask, hideLoadmask: hideLoadmask };


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-redux-loadmask/lib/shared/actions.js
 ** module id = 501
 ** module chunks = 0
 **/